import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../assets/images/arka-saydam-logo.png';

const Header = ({ isDarkMode, toggleDarkMode, onMenuToggle }) => {
  const location = useLocation();
  const isLandingSurface = location.pathname === '/' || location.pathname === '/landing-lab';
  const ozelliklerHref = isLandingSurface ? '#ozellikler' : '/#ozellikler';
  const premiumHref = isLandingSurface ? '#premium' : '/#premium';

  return (
    <header className="fixed top-0 z-50 w-full border-b border-[#f5f0f0] bg-white/90 backdrop-blur-md dark:border-gray-800 dark:bg-[#1a1a1a]/90">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-2 md:h-20 md:px-6 lg:px-8">
        <div className="min-w-0 flex items-center gap-2 md:gap-3">
          {onMenuToggle && (
            <button className="mr-3 inline-flex items-center justify-center rounded-lg p-2 md:hidden" onClick={onMenuToggle} aria-label="Toggle sidebar">
              <i className="fa-solid fa-bars text-[20px]"></i>
            </button>
          )}
          <Link to="/" className="flex min-w-0 items-center gap-2 md:gap-3">
            <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-lg bg-primary/10 text-primary md:h-10 md:w-10">
              <img src={Logo} alt="Bana Bir Tarif Ver Logo" className="w-full h-full object-contain" />
            </div>
            <span className="truncate whitespace-nowrap text-[13px] font-black tracking-tight text-text-main dark:text-white sm:text-sm md:text-xl">
              Bana Bir Tarif Ver
            </span>
          </Link>
        </div>

        <nav className="hidden items-center gap-8 md:flex">
          <a className="text-sm font-semibold text-text-main transition-colors hover:text-primary dark:text-gray-200" href={ozelliklerHref}>
            Özellikler
          </a>
          <a className="text-sm font-semibold text-text-main transition-colors hover:text-primary dark:text-gray-200" href={premiumHref}>
            Premium Özellikler
          </a>
          <Link className="text-sm font-semibold text-text-main transition-colors hover:text-primary dark:text-gray-200" to="/sss">
            S.S.S
          </Link>
          <Link className="text-sm font-semibold text-text-main transition-colors hover:text-primary dark:text-gray-200" to="/blog">
            Blog
          </Link>
          <Link className="text-sm font-semibold text-text-main transition-colors hover:text-primary dark:text-gray-200" to="/hakkimizda">
            Hakkımızda
          </Link>
        </nav>

        <div className="hidden items-center gap-4 md:flex">
          <Link
            to="/giris-yap"
            className="flex h-10 items-center justify-center rounded-lg px-4 text-sm font-bold text-text-main transition-colors hover:bg-gray-100 dark:text-white dark:hover:bg-white/10 md:px-6"
          >
            Giriş Yap
          </Link>

          <button
            onClick={toggleDarkMode}
            className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100 text-text-main transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-primary dark:hover:text-white"
            type="button"
          >
            <span className="material-symbols-outlined text-xl">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
          </button>

          <Link
            to="/kayit-ol"
            className="flex h-10 items-center justify-center rounded-lg bg-primary px-6 text-sm font-bold text-white shadow-lg shadow-primary/20 transition-all hover:scale-105 active:scale-95"
          >
            Kayıt Ol
          </Link>
        </div>

        <div className="flex items-center gap-2 md:hidden">
          <div className="flex items-center gap-1.5">
            <Link
              to="/giris-yap"
              className="inline-flex h-8 items-center justify-center rounded-lg border border-slate-300 bg-white px-2.5 text-[10px] font-bold text-slate-800 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100"
            >
              Giriş Yap
            </Link>
            <Link
              to="/kayit-ol"
              className="inline-flex h-8 items-center justify-center rounded-lg bg-primary px-3 text-[11px] font-bold text-white shadow-md shadow-primary/20"
            >
              Kayıt Ol
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
